import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles?: IGenericObject) => {
  const maxColumns = 3;
  const minColumns = 2;
  const gap = 30;

  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: `0px ${gap / 2}px`,
      boxSizing: 'content-box',
      width: `calc(${100 / minColumns - 1}% - ${gap}px)`,
      marginBottom: '36px',
      [media.tablet]: {
        marginBottom: '50px',
      },
      [media.desktop]: {
        width: `calc(${100 / maxColumns - 1}% - ${gap}px)`,
        marginBottom: '60px',
      },
    },

    thumbnail: {
      position: 'relative',
      width: '100%',
      [children('img')]: {
        width: '100%',
      },
    },

    playButton: {
      width: '100%',
      paddingBottom: '16px',
      marginTop: '18px',
      borderBottom: '1px solid #E60012',
      [media.tablet]: {
        paddingBototm: '18x',
      },
      [media.desktop]: {
        paddingBottom: '15px',
        borderBottom: '1px solid #E60012',
      },

      [children('button')]: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        verticalAlign: 'center',
        background: 'transparent',
        border: 0,
        color: '#fff',
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 'bold',
        margin: 0,
        padding: 0,
        cursor: 'pointer',
        [media.tablet]: {
          fontSize: '20px',
          lineHeight: '22px',
        },
        [media.desktop]: {
          fontSize: '16px',
          lineHeight: '22px',
          ':hover': {
            color: palette.red,
          },
        },

        [children('span')]: {
          height: '20px',
          width: 'auto',
          marginRight: '10px',
          [media.tablet]: {
            height: '25px',
          },
          [media.desktop]: {
            height: '21px',
          },
        },
        [children('svg')]: {
          height: '100%',
          width: 'auto',
          fill: palette.red,
        },
      },
    },
    abstractAndBioButton: {
      fontSize: '14px',
      lineHeight: '20px',
      width: 'fit-content',
      padding: '0px 10px',
      margin: '15px 0px',

      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      [media.desktop]: {
        width: 'fit-content',
        padding: '0px 6px',
        margin: '15px 4px',
        transition: 'all 0.2s linear',
        ':hover': {
          height: '34px',
          padding: '0px 10px',
          margin: '15px 0px',
        },
      },
    },
    category: {
      color: palette.red,
      marginBottom: 0,
      fontSize: 12,

      [media.tablet]: {
        marginBottom: 0,
      },

      [media.desktop]: {
        marginBottom: 0,
      },
    },
    title: {
      color: palette.white,
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 'bold',
      marginBottom: 5,

      [media.tablet]: {
        fontSize: '20px',
        lineHeight: '24px',
      },

      [media.desktop]: {
        fontSize: '18px',
        lineHeight: '24px',
        marginBottom: 10,
      },
    },

    speakers: {
      color: '#C1C0C0',
      marginBottom: 5,
      fontSize: '12px',
      lineHeight: '16px',
      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },

    companies: {
      color: '#C1C0C0',
      fontWeight: 'bold',
      marginBottom: 5,
      fontSize: '12px',
      lineHeight: '16px',
      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
  });
};
